
import { Component, Prop, Vue } from "vue-property-decorator";

type Tile = {
  name: string;
};

@Component
export default class ManagementCompanyComponent extends Vue {
  @Prop(Object) readonly tile!: Tile;
}
